module.exports = __webpack_public_path__ + "img/dku.00118.3786bf44.png";